
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.385 1.635c-7.042 0-12.75 5.709-12.75 12.75 0 7.042 5.708 12.75 12.75 12.75 7.041 0 12.75-5.709 12.75-12.75s-5.709-12.75-12.75-12.75z","stroke":"#fff","stroke-width":"1.5","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M14.385 1.635c-3.56 0-6.907 5.709-6.907 12.75 0 7.042 3.347 12.75 6.907 12.75s6.906-5.709 6.906-12.75-3.346-12.75-6.906-12.75z","stroke":"#fff","stroke-width":"1.5","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M5.884 5.884c2.345 1.665 5.296 2.657 8.5 2.657 3.206 0 6.157-.992 8.501-2.657M22.885 22.885c-2.344-1.664-5.295-2.656-8.5-2.656s-6.156.992-8.5 2.656","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.385 1.635v25.5M27.135 14.385h-25.5","stroke":"#fff","stroke-width":"1.5","stroke-miterlimit":"10"}})])
          )
        }
      }
    